import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableEnginDetailsPage = withAsyncLoading(async () =>
    import('./EnginDetailsPage').then((res) => res.EnginDetailsPage)
);

export { LoadableEnginDetailsPage };
